import React, { useEffect } from 'react'
import './domain-integrations-manager.scss'

import { getClassNames } from '../../_utils/classnames'
import { DomainIntegrationService } from '../../services'
import { AppState } from '../../stores/app'
import { DomainIntegrationsManagerDispatchContext, domainIntegrationsManagerReducer } from './reducer'
import { DomainIntegrationsManagerContext } from './context'
import { DataPlatformIntegrations } from './categories/data-platforms'
import { useService } from '@pushly/aqe/lib/hooks/use-service'
import { CommunicationPlatformIntegrations } from './categories/communication-platforms'
import { CmsIntegrations } from './categories/cms-platforms'
import { EcommIntegrations } from './categories/ecomm-platforms'
import { Flex, Row } from 'antd'
import { VERTICAL_WELL_GAP } from '../../theme/constants'

export const DomainIntegrationsManager = () => {
    const { currentDomain } = useService(AppState)
    const diSvc = useService(DomainIntegrationService)

    const [context, dispatch] = React.useReducer(domainIntegrationsManagerReducer, {
        loading: true,
        domain: currentDomain,
    })

    useEffect(() => {
        if (currentDomain?.id && currentDomain.id !== context.domain?.id) {
            dispatch({ type: 'set-domain', domain: currentDomain })
        }
    }, [currentDomain?.id, context.domain?.id])

    useEffect(() => {
        async function _loadIntegrations(_domainId: number) {
            const res = await diSvc.fetchAll(_domainId, {
                query: { pagination: false },
                showLoadingScreen: !context.integrations_reload_requested,
            })

            dispatch({ type: 'set-integrations', integrations: res.data ?? [] })
        }

        if (context.domain?.id || context.integrations_reload_requested) {
            if (context.integrations_reload_requested && !context.domain) {
                console.warn('Domain not found, reloading integrations cancelled')
                return
            }
            _loadIntegrations(context.domain!.id)
        }
    }, [context.domain?.id, context.integrations_reload_requested])

    return (
        <DomainIntegrationsManagerContext.Provider value={context}>
            <DomainIntegrationsManagerDispatchContext.Provider value={dispatch}>
                <div className={getClassNames('domain-integrations-manager')}>
                    <Flex gap={VERTICAL_WELL_GAP} wrap className="integrations-list">
                        <CommunicationPlatformIntegrations />
                        <CmsIntegrations />
                        <EcommIntegrations />
                        <DataPlatformIntegrations />
                    </Flex>
                </div>
            </DomainIntegrationsManagerDispatchContext.Provider>
        </DomainIntegrationsManagerContext.Provider>
    )
}
